import script from "./FormGeolocationCompletedByPartner.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGeolocationCompletedByPartner.vue?vue&type=script&setup=true&lang=ts"

import "./FormGeolocationCompletedByPartner.vue?vue&type=style&index=0&id=115d65e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115d65e8"]])

export default __exports__